"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _constants = require("./constants");

var _AdRoll = _interopRequireDefault(require("./AdRoll"));

var _GoogleAnalytics = _interopRequireDefault(require("./GoogleAnalytics"));

var _Drift = _interopRequireDefault(require("./Drift"));

var INHERIT_INTEGRATION_VALUE = {
  enabled: null
}; // For each integration, if it doesn't exist, that means that we want
// to inherit from the all-domains level, to help indiciate this to the UI
// we set the enabled value to "null"

var sanitizeIntegrations = function sanitizeIntegrations(settings) {
  var jsIntegrationsProps = settings[_constants.JS_INTEGRATIONS] || {};

  if (!settings[_constants.JS_INTEGRATIONS]) {
    settings[_constants.JS_INTEGRATIONS] = {};
  }

  var adRoll = jsIntegrationsProps[_constants.AD_ROLL] || INHERIT_INTEGRATION_VALUE;
  settings[_constants.JS_INTEGRATIONS][_constants.AD_ROLL] = new _AdRoll.default(adRoll);
  var googleAnalytics = jsIntegrationsProps[_constants.GOOGLE_ANALYTICS] || INHERIT_INTEGRATION_VALUE;
  settings[_constants.JS_INTEGRATIONS][_constants.GOOGLE_ANALYTICS] = new _GoogleAnalytics.default(googleAnalytics);
  var drift = jsIntegrationsProps[_constants.DRIFT] || INHERIT_INTEGRATION_VALUE;
  settings[_constants.JS_INTEGRATIONS][_constants.DRIFT] = new _Drift.default(drift);
  return settings;
};

var SiteSettings =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(SiteSettings, _Record);

  function SiteSettings(props) {
    (0, _classCallCheck2.default)(this, SiteSettings);

    if (props[_constants.ATTACHED_STYLESHEETS]) {
      props[_constants.ATTACHED_STYLESHEETS] = props[_constants.ATTACHED_STYLESHEETS].reduce(function (acc, stylesheet) {
        return acc.set(stylesheet.id, stylesheet);
      }, (0, _immutable.OrderedMap)());
    }

    var sanitizedSettings = sanitizeIntegrations(props);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SiteSettings).call(this, sanitizedSettings));
  }

  return SiteSettings;
}((0, _immutable.Record)({
  accountFromAddressProperties: null,
  accountFromNameProperties: null,
  accountMergeTagDefaults: null,
  addDomainLangToSlug: null,

  /* Extra unique identifier property injected to help with staging */
  allDomainsOrDomainName: null,
  attachedStylesheets: null,
  author: null,
  backgroundColor: null,
  body: null,
  bodyBorderColor: null,
  bodyBorderColorChoice: null,
  bodyColor: null,
  bodyOverrideByDomain: null,
  classicMigrationStatus: null,
  colorPickerFavorite1: null,
  colorPickerFavorite2: null,
  colorPickerFavorite3: null,
  colorPickerFavorite4: null,
  colorPickerFavorite5: null,
  colorPickerFavorite6: null,
  colorPickerFavorite_1: null,
  colorPickerFavorite_2: null,
  colorPickerFavorite_3: null,
  colorPickerFavorite_4: null,
  colorPickerFavorite_5: null,
  colorPickerFavorite_6: null,
  companyCanSpamInfo: null,
  companyCity: null,
  companyCountry: null,
  companyDomain: null,
  companyName: null,
  companyPhone: null,
  companyState: null,
  companyStreetAddress1: null,
  companyStreetAddress2: null,
  companyStreetAddress_1: null,
  companyStreetAddress_2: null,
  companyZip: null,
  contentLanguage: null,
  contentSearchResultsPagePath: null,
  contentSearchResultsTemplatePath: null,
  custom404: null,
  custom500: null,
  customFromNames: null,
  ENABLE_LANGUAGE_SPECIFIC_REDIRECTS: 'enableLanguageSpecificRedirects',
  customPasswordTemplatePath: null,
  customReplyToEmails: null,
  customSubscriptionConfirmation: null,
  customSubscriptionPreferences: null,
  customUnsubscribeSimple: null,
  defaultFileHostingDomain: null,
  emailBccSettingConfirmed: null,
  emailBccSettingEmail: null,
  emailBccSettingEnabled: null,
  emailBodyPadding: null,
  emailBodyWidth: null,
  emailOptinEnabled: null,
  emailOptinConfirmationPageId: null,
  emailOptinFollowupEnabled: null,
  emailPublishers: null,
  emailResubscribeConfirmationEnabled: null,
  emailResubscribeContentId: null,
  emailResubscribeEnabled: null,
  emailRssDateFormat: null,
  emailRssDateLanguage: null,
  emailUnsubscribeConfirmationEnabled: null,
  enableLanguageSpecificRedirects: null,
  faviconAlt: null,
  faviconHeight: null,
  faviconSrc: null,
  faviconUrl: null,
  faviconWidth: null,
  footerHtml: null,
  fromAddressProperties: null,
  fromNameProperties: null,
  googleAnalyticsAccount: null,
  graymailSuppressionEnabledByDefault: null,
  hasDismissedAutomatedEmailRecipeMessage: null,
  hasHubspotEmailFooter: null,
  hasSeenTemplateBuilderNewLayoutDragAndDropWelcomeMessage: null,
  hasSeenTemplateBuilderWelcomeMessage: null,
  headHtml: null,
  id: null,
  includeJquery: null,
  includeJqueryInFooter: null,
  includeJQueryMigrate: null,
  jqueryVersion: null,
  jsIntegrations: null,
  label: null,
  logoAlt: null,
  logoHasUserChanges: null,
  logoHeight: null,
  logoSrc: null,
  logoWidth: null,
  mergeTagDefaults: null,
  officeLocationName: null,
  ownerMergeTagDefaults: null,
  pageAccountMergeTagDefaults: null,
  pageMergeTagDefaults: null,
  pageOwnerMergeTagDefaults: null,
  performableMigrationStatus: null,
  partitioningActivatedForBlogPosts: null,
  partitioningActivatedForLandingPages: null,
  partitioningActivatedForDomainPublishing: null,
  portalId: null,
  primaryAccentColor: null,
  primaryFont: null,
  primaryFontColor: null,
  primaryFontSize: null,
  robotsTxt: null,
  robotsTxtTouched: null,
  secondaryAccentColor: null,
  secondaryFont: null,
  secondaryFontColor: null,
  secondaryFontSize: null,
  selfLinkRelCanonicalizePagesAndBlogPosts: null,
  selfLinkRelCanonicalizeBlogListingPages: null,
  siteId: null,
  siteMapIncludes: null,
  themeNumber: null,
  utmAutomaticPlainTextTracking: null,
  utmAutomaticTracking: null,
  utmIdentityTracking: null,
  utmSourceTracking: null,
  hstsMaxAge: null,
  isHstsPreloadEnabled: null,
  isHstsIncludeSubdomainsEnabled: null,
  membershipCompanyName: null,
  membershipWebsiteAdmin: null,
  membershipRegistrationRedirectId: null,
  membershipLoginRedirectId: null,
  membershipLogoutRedirectId: null,
  membershipRegistrationTemplateId: null,
  membershipLoginTemplateId: null,
  membershipPasswordResetRequestTemplateId: null,
  membershipPasswordResetTemplateId: null,
  membershipAccessDeniedTemplateId: null,
  membershipLogoutTemplateId: null,
  membershipRegistrationEmailTemplateId: null,
  membershipPasswordResetEmailTemplateId: null,
  membershipPasswordSavedEmailTemplateId: null
}, _constants.SITE_SETTINGS));

exports.default = SiteSettings;
module.exports = exports.default;